// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_auth_auth_module_ts":"4020f2bb6a0a0977","src_app_modules_insights_insights_module_ts":"bcf94f59e95b7b5b","src_app_modules_workbench_workbench_module_ts":"a8696340cc2dedd0"}[chunkId] + ".js";
};